import {
  IAliasInOtherCountry,
  ICategoryAsset, ICustomCategoryAsset,
  IVirtualCatAsset,
} from "models/Assets/ICategoryAsset";
import { __fetchServerSide } from "../../../private/__fetch";
import { NextPageContextEnhanced } from "../../../types/page";
import {TypeAllowedCustomLandingBaseNames} from "componentScreens/LandingPages";

export const getCategoryByCustomBaseName = (
  baseName: TypeAllowedCustomLandingBaseNames
): ICustomCategoryAsset => {
  let category: ICustomCategoryAsset;
  switch (baseName) {
    case "real-estate":
      category = {
        id: "real-estate",
        url_name_en: "real-estate",
        url_name_ar: "عقارات",
        label_en: "ٍReal Estate",
        label_ar: "عقارات",
        reporting_name: "RealEstate",
      };
      break;
    case "fashion":
      category = {
        id: "fashion",
        url_name_en: "fashion",
        url_name_ar: "أزياء",
        label_en: "Fashion",
        label_ar: "أزياء",
        reporting_name: "Fashion",
      };
      break;
    case "electronics":
      category = {
        id: "electronics",
        url_name_en: "electronics-appliances",
        url_name_ar: "اجهزة-الكترونيات",
        label_en: "Electronics",
        label_ar: "الكترونيات",
        reporting_name: "Electronics",
      };
      break;
    case "عقارات":
    category = {
      id: "real-estate",
      url_name_en: "real-estate",
      url_name_ar: "عقارات",
      label_en: "ٍReal Estate",
      label_ar: "عقارات",
      reporting_name: "RealEstate",
    };
      break;
    case "أزياء":
      category = {
        id: "fashion",
        url_name_en: "fashion",
        url_name_ar: "أزياء",
        label_en: "Fashion",
        label_ar: "أزياء",
        reporting_name: "Fashion",
      };
      break;
    case "الكترونيات":
      category = {
        id: "electronics",
        url_name_en: "electronics-appliances",
        url_name_ar: "اجهزة-الكترونيات",
        label_en: "Electronics",
        label_ar: "الكترونيات",
        reporting_name: "Electronics",
      };
      break;
  }

  return category;
};
export const getAllCategories = async (
  context: NextPageContextEnhanced,
  forceFresh: boolean = false
): Promise<ICategoryAsset[]> => {
  if (!context.countryCode) return [];
  const url = `categories?expand=subCategories&fields=has_price,reporting_name,label_ar,label_en,id,icon,has_child,url_name_ar,url_name_en,order,url_limit_depth`;

  const data = await __fetchServerSide(
    url,
    context,
    process.env.API_CACHE_INFINITY,
    null,
    forceFresh
  );

  await __fetchServerSide(
    "categories/labels",
    context,
    process.env.API_CACHE_INFINITY
  )
    .then((data2: { [reportingName: string]: IAliasInOtherCountry[] }) => {
      (data.items as ICategoryAsset[]).forEach((category, index) => {
        (data.items[index] as ICategoryAsset).aliasesInOtherCountries =
          (data.items[index] as ICategoryAsset).aliasesInOtherCountries || {};
        (data2[category.reporting_name] as IAliasInOtherCountry[]).forEach(
          (s) => {
            (data.items[index] as ICategoryAsset).aliasesInOtherCountries[
              s.country
            ] = s;
          }
        );

        category.subCategories.forEach((subCategory, index2) => {
          (data.items[index] as ICategoryAsset).subCategories[
            index2
          ].aliasesInOtherCountries =
            (data.items[index] as ICategoryAsset).subCategories[index2]
              .aliasesInOtherCountries || {};
          (data2[subCategory.reporting_name] as IAliasInOtherCountry[]).forEach(
            (s2) => {
              (data.items[index] as ICategoryAsset).subCategories[
                index2
              ].aliasesInOtherCountries[s2.country] = s2;
            }
          );
        });
      });
    })
    .catch((err) => {
      console.error("categories/labels not implemented yet!");
    });

  return data.items;
};

export const getAllVirtualCategories = async (
  context: NextPageContextEnhanced
): Promise<IVirtualCatAsset[]> => {
  if (!context.countryCode) return [];
  let url = `virtual-category?context=/ScreenHome&fields=reporting_name,name_ar,name_en,buyer_weblink_ar,buyer_weblink_en,id,icon_name,tag_label_ar,tag_label_en`;
  const data = await __fetchServerSide(
    url,
    context,
    process.env.API_CACHE_INFINITY
  );
  if (Array.isArray(data)) return data;
  return [];
};
